import script from "./VerifyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyForm.vue?vue&type=script&setup=true&lang=js"

import "./VerifyForm.vue?vue&type=style&index=0&id=6a1274e8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1274e8"]])

export default __exports__